import moment from "moment"

export const dateFormater = (date) => {
    return moment(new Date(date)).format("DD/MM/YYYY");
}

export const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  apheresis_date: {
    label: "Apheresis Date",
  },
};

export const filterConfigRecived = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
};

export const filterConfigStatus = {
  status: {
    label: "status",
    enum: {
      0: "Pending",
      1: "Submitted",
      2: "Published",
      3: "Draft",
    },
  },
    versions: {
    label: "versions",
   
  },
};
